module.exports = __webpack_public_path__ + "img/0xe64f5cb844946c1f102bd25bbd87a5ab4ae89fbe.8b71263f.png";